export default "__VITE_ASSET__CF0MCpIb__"